import PropTypes from 'prop-types';

export const formPropTypes = {
	recordId: PropTypes.number,
	closeModal: PropTypes.func,
};

export const formDefaultPropValues = {
	recordId: null,
	closeModal: null,
};

export const displayedHeadersPropType = PropTypes.arrayOf(
	PropTypes.shape({
		key: PropTypes.string.isRequired,
		displayedHeader: PropTypes.string,
		displayedLength: PropTypes.number,
		type: PropTypes.string,
	})
);

export const displayedHeaderDefaultProps = [
	{
		key: 0,
		displayedHeader: '',
		displayedLength: 64,
		type: 'string',
	},
];
